var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 176,
    viewBox: "0 0 178 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4455 78.3359L95.807 81.4655C95.9291 81.5061 96.0512 81.4249 96.092 81.3232L115.099 14.7862C110.112 11.7582 105.802 11.0672 103.95 10.9453L85.3234 78.0514C85.2623 78.1733 85.3234 78.2952 85.4455 78.3359Z",
    fill: "url(#paint0_linear_439_199)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3647 91.8847L78.8889 85.2569L77.5657 83.8344L9.85541 102.38C9.93683 103.274 10.0997 104.229 10.4254 105.225C11.2804 107.928 12.7867 109.777 13.886 110.834L79.7235 92.7152L82.3647 91.8847Z",
    fill: "url(#paint1_linear_439_199)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0358 89.36L88.7254 95.1518L88.4607 96.0053L139.785 149.389C141.617 146.483 143.429 143.576 145.261 140.67L95.7687 89.1974L95.0358 89.36Z",
    fill: "url(#paint2_linear_439_199)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.274 57.4512L124.64 6.66611C119.49 1.17913 111.775 -1.15792 104.426 0.549142L36.558 16.3598C29.2094 18.0668 23.3467 23.5538 21.1482 30.7682L0.913942 97.3435C-1.28455 104.558 0.547524 112.382 5.71806 117.869L53.3724 168.654C58.5226 174.141 66.2377 176.478 73.5864 174.771L141.455 158.96C148.803 157.253 154.666 151.766 156.865 144.552L177.099 77.9765C179.277 70.7825 177.445 62.9585 172.274 57.4512ZM59.8051 158.94C45.006 142.825 30.2068 126.709 15.4077 110.594C15.2042 110.431 14.9192 110.187 14.6138 109.882C14.5731 109.842 14.5324 109.801 14.4713 109.76C13.3721 108.683 11.8453 106.834 11.0107 104.151C10.685 103.156 10.5222 102.201 10.4407 101.306C10.4407 101.245 10.4204 101.205 10.4204 101.144C10.2575 98.9896 10.6443 97.3029 10.8682 96.49L31.5504 35.5439L77.8001 85.4348L79.1233 86.8573L81.505 89.4179L80.4872 92.6694L79.9172 94.4984L59.8051 158.94ZM145.241 140.02C143.327 143.15 141.394 146.279 139.48 149.409C116.946 154.083 94.4313 158.777 71.8968 163.472L91.7443 98.5426L92.0293 97.6077L93.5967 92.5069L98.6858 91.3892L99.4594 91.2266L162.707 77.3669C156.885 98.2377 151.063 119.129 145.241 140.02ZM88.9962 79.1552L42.1357 26.5209L104.691 12.3766C104.691 12.3766 105.139 12.3157 105.973 12.3766C107.826 12.4986 111.592 13.1895 116.579 16.2175C119.124 17.762 121.994 19.9162 125.088 22.9442C136.976 34.5278 162.707 65.3565 162.707 65.3565L88.9962 79.1552Z",
    fill: "#2469A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_199",
    x1: 90.8962,
    y1: 81.8162,
    x2: 143.368,
    y2: 24.2445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2469A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_439_199",
    x1: 85.0688,
    y1: 87.66,
    x2: -17.6183,
    y2: 93.3515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2469A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63735,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_439_199",
    x1: 94.3899,
    y1: 94.6728,
    x2: 123.222,
    y2: 154.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2469A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLogo);
export default __webpack_public_path__ + "static/media/blueLogo.fba458622810b9a91c009ccc535559d0.svg";
export { ForwardRef as ReactComponent };